import React, { useState } from 'react';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import { getImageBaseUrl } from 'helpers/request';
import { appendModalToDom } from 'helpers/modal';
import Modal from 'components/_utility/Modal/Modal';
import OfferDetailsModal from 'components/OfferDetailsModal';
import ResponsiveImage from 'components/_utility/BackgroundImage/ResponsiveImage';
import useDataLayer from 'src/hooks/useDataLayer';
import { Wrap, ContentWrap, Content, Title, InfoIconBtn, Description, ImageWrap } from './OfferBanner.styled';

const OfferBanner = ({ offerBanner }) => {
  appendModalToDom('purchase-intent-modal', { zIndex: 10001 });
  const { image, long_description: longDescription, short_description: shortDescription, title } = offerBanner;
  const [modalOpen, setModalOpen] = useState(false);
  const pushToDataLayer = useDataLayer();

  return (
    <>
      <Wrap>
        {image && (
          <ImageWrap>
            <ResponsiveImage
              mobile={getImageBaseUrl() + image?.srcMediumNarrow}
              mobileLarge={getImageBaseUrl() + image?.srcLarge}
              tablet={getImageBaseUrl() + image?.srcMediumWidest}
              alt={image?.altText}
            />
          </ImageWrap>
        )}
        <ContentWrap>
          <Content>
            <Title>
              {title}
              <InfoIconBtn
                onClick={() => {
                  setModalOpen(!modalOpen);
                  pushToDataLayer('purchaseOffOpen');
                }}
              >
                <InfoIcon />
              </InfoIconBtn>
            </Title>
            <Description>{shortDescription}</Description>
          </Content>
        </ContentWrap>
      </Wrap>
      {modalOpen && (
        <Modal onClose={() => setModalOpen(false)}>
          <OfferDetailsModal title={title} longDescription={longDescription} />
        </Modal>
      )}
    </>
  );
};

export default OfferBanner;
